import React from "react";
import { Box, Typography } from "@mui/material";

interface TruncatedTextProps {
  text: string;
  subtext?: string | undefined | null;
  fontSize?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  showHoverEffect?: boolean;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  subtext,
  fontSize = "1rem",
  onClick,
  showHoverEffect = false,
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        fontSize,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        cursor: onClick ? "pointer" : "default",
        ...(showHoverEffect && {
          "&:hover": {
            textDecoration: "underline",
          },
        }),
      }}
    >
      {text}
      {subtext && (
        <Typography
          variant="caption"
          color="text.secondary"
          fontStyle={"italic"}
        >
          {" " + subtext}
        </Typography>
      )}
    </Box>
  );
};
